/**
 * Controller: TemplatesCreateSchedulesOpeningHoursModal
 */
angular.module('acme.view.application.templates.create.schedules.openingHours.controllers', [])
.controller('TemplatesCreateSchedulesOpeningHoursModalController', [ '$scope', '$uibModalInstance', 'openHours', 'closedHours', 'hourFormat', function ($scope, $uibModalInstance, openHours, closedHours, hourFormat) {

    $scope.errors = [];

    $scope.model = {
      open: [],
      closed: []
    };

    $scope.init = function() {
      this.model = {
        open: openHours,
        closed: closedHours,
        hourFormat: hourFormat
      };
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.hasOpenHours = function() {
      return (this.model.open instanceof Array && this.model.open.length);
    };

    $scope.hasClosedHours = function() {
      return (this.model.closed instanceof Array && this.model.closed.length);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);